const COMPLIANCE = {
    BENEFITS: {
        RESOURCE_ID: 'complianceBenefits',
    },
    CALENDAR: {
        RESOURCE_ID: 'complianceCalendar',
        URL: '/hr-compliance/compliance-calendar',
        PARENT_ID: 'complianceCalendar',
    },
    CALENDAR_EVENT_ADD: {
        RESOURCE_ID: 'complianceCalendarEventAdd',
    },
    CALENDAR_EVENT_ALL: {
        RESOURCE_ID: 'complianceCalendarEventAll',
    },
    DISCRIMINATION_AND_EQUAL_EMPLOYMENT: {
        RESOURCE_ID: 'complianceDiscriminationEqualEmployment',
    },
    HIRING: {
        RESOURCE_ID: 'complianceHiring',
    },
    HR_ASSESSMENT: {
        RESOURCE_ID: 'hrFitnessTest',
    },
    LANDING_PAGE: {
        RESOURCE_ID: 'compliance',
    },
    LAWS: {
        RESOURCE_ID: 'complianceLaws',
    },
    LAW_ALERTS: {
        RESOURCE_ID: 'complianceLawAlerts',
    },
    LEAVES_AND_TIME_OFF: {
        RESOURCE_ID: 'complianceLeavesTimeOff',
    },
    MANAGING_EMPLOYEES: {
        RESOURCE_ID: 'compliancemanagingemployees',
    },
    SAFETY_AND_HEALTH: {
        RESOURCE_ID: 'complianceSafetyAndHealth',
    },
    TERMINATION: {
        RESOURCE_ID: 'complianceTermination',
    },
    WAGE_AND_HOUR: {
        RESOURCE_ID: 'complianceWagehour',
    },
};

export default COMPLIANCE;
